import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-chart-zoom-modal',
  templateUrl: './chart-zoom-modal.component.html',
  styleUrls: ['./chart-zoom-modal.component.scss']
})
export class ChartZoomModalComponent {
  zoomedChart: Chart;
  title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ChartZoomModalComponent>
  ) {
    this.title = data.title;
    // We recreate the chart using the original options to ensure it fits the modal size
    this.zoomedChart = new Chart(data.chartOptions);
  }

  close(): void {
    this.dialogRef.close();
  }
}
